import { render, staticRenderFns } from "./RepresentacionAprobar.vue?vue&type=template&id=6ad0dbbc&scoped=true&"
import script from "./RepresentacionAprobar.vue?vue&type=script&lang=js&"
export * from "./RepresentacionAprobar.vue?vue&type=script&lang=js&"
import style0 from "./RepresentacionAprobar.vue?vue&type=style&index=0&id=6ad0dbbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad0dbbc",
  null
  
)

component.options.__file = "RepresentacionAprobar.vue"
export default component.exports